import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationBilling(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.BILLING, { keyPrefix });

  return t;
}

export default useTranslationBilling;
